const separatorStyle = { background: '#d7d8da', height: '1px', margin: '20px 0px' };
const Separator: React.FC<{ style?: object }> = ({ style = {} }) => (
    <div id="separator" className="separator" style={{ ...separatorStyle, ...style }}></div>
);
export default Separator;
